export default class Service {
    constructor(titles,descriptions,image) {
        this.titles = titles;
        this.descriptions = descriptions;
        this.image = image;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; } }
        for (const [key, value] of Object.entries(this.descriptions)) { if(!value) { result = false; break; } }

        if(result) result = this.image;

        return result;
    }
}